import $axios from '@/core/api.service'
import { useInvestorStore } from '@/stores/investor'
import i18n from '../i18n'
import localstorageService from '../core/localstorage.service'

class InvestorService {
  getInvestors () {
    return $axios.get('/api/investor')
  }

  validateCurrentInvestor (investors) {
    const localInvestor = localstorageService.getItem('currentInvestor')
    const investorId = localstorageService.getItem('investorId')
    let investor = null

    if (investorId) {
      investor = investors.find(item => item.id === investorId)
    }

    if (localInvestor && investors.find(i => i.id === localInvestor.id)) {
      investor = investors.find(i => i.id === localInvestor.id)
    }

    if (!investor) {
      investor = investors[0]
    }

    return investor
  }

  updateInvestor (data) {
    /* No trailing slash: the server 301s `/api/investor/{id}/` to the slashless
       form, and a redirect on a preflighted cross-origin POST is rejected by the
       browser as a CORS failure. Every other endpoint here is already slashless. */
    return $axios.post(`/api/investor/${data.id}`, data)
  }

  getAccounts () {
    const investorStore = useInvestorStore()
    return $axios.get(`/api/accounts/${investorStore.currentInvestor.id}?locale=${i18n.global.locale.value}`)
  }

  getSectors () {
    const investorStore = useInvestorStore()
    return $axios.get(`/api/sectors/${investorStore.currentInvestor.id}`).then(({ data }) => {
      // sort sectors by value
      return data.sort((a, b) => (b.value > a.value ? 1 : a.value > b.value ? -1 : 0))
    })
  }
}

export default new InvestorService()
